import React, {useMemo} from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

import { Header2 } from '../utils/Header'

import Sms from './Sms'
import Renew from './Renew'
import EnterAmount from './EnterAmount'

const activeProductClass = 'border-green-600 bg-green-100 shadow-md shadow-green-300'
const inactiveProductClass = 'border-gray-200 bg-gray-100'

const CheckCircle = () => <FontAwesomeIcon icon={faCheckCircle} className=" float-right text-2xl text-green-500" />
const Thanks = ({ onChange, defaultValue, product, setProductSelected }) => {
  const user = useSelector(store => store.user.userV2)

  const renewSelected = useMemo(() => product.key === 'renew', [product])
  const smsSelected = useMemo(() => product.key === 'sms', [product])
  const thanksSelected = useMemo(() => product.key === 'thanks', [product])

  return (
    <div className="">
      <Header2>You Love Wandering Labs</Header2>
      <p className="text-lg mb-2">Reach out with any questions or comments: info@wanderinglabs.com</p>

      <div className={clsx("border-2 p-4 rounded-lg mb-4", thanksSelected ? activeProductClass : inactiveProductClass)} onClick={() => setProductSelected('thanks')} >
        {thanksSelected && <CheckCircle />}
        <div className="text-lg font-semibold">Say Thanks To WanderingLabs</div>
        <div className="text-sm text-gray-400 mb-2">Extra tip for being awesome</div>
        <EnterAmount onChange={onChange} defaultValue={defaultValue} standalone={false} />
      </div>

      <div className={clsx("border-2 p-4 rounded-lg mb-4", renewSelected ? activeProductClass : inactiveProductClass)} onClick={() => setProductSelected('renew')} >
        {renewSelected && <CheckCircle />}
        <div className="text-lg font-semibold">Renew your Premium Membership</div>
        <div className="text-sm text-gray-400 mb-2">Expires on: {user.premiumUntil}</div>
        <Renew onChange={onChange} defaultValue={defaultValue} standalone={false} />
      </div>

      <div className={clsx("border-2 p-4 rounded-lg mb-4", smsSelected ? activeProductClass : inactiveProductClass)} onClick={() => setProductSelected('sms')} >
        {smsSelected && <CheckCircle />}
        <div className="text-lg font-semibold mb-2">Add additional SMS Capacity</div>
        <Sms onChange={onChange} defaultValue={defaultValue} standalone={false} />
      </div>

    </div>
  )
}

export default Thanks
